import { components } from '@/types/api';
import { formatDate, parseISO } from 'date-fns';
import { useMemo } from 'react';
import SingleReceipt from '@/assets/icons/single_receipt.svg?react';
import EnrichedReceipt from '@/assets/icons/enriched_receipt.svg?react';
import { Link, useParams } from 'wouter';

export default function TransactionBlock({
  receipt,
}: {
  receipt: components['schemas']['ReceiptOutput'];
}) {
  const { receiptId } = useParams<'/receipts/:receiptId'>();

  const formattedTransactionDate = useMemo(() => {
    return receipt.transaction_date
      ? formatDate(parseISO(receipt.transaction_date), 'MM/dd/yyyy')
      : null;
  }, [receipt.transaction_date]);

  const formattedProcessedDate = useMemo(() => {
    return formatDate(new Date(receipt.created_at), 'MM/dd/yyyy');
  }, [receipt.created_at]);

  return (
    <>
      <div className="flex items-start justify-between px-3">
        <div className="flex items-center gap-4">
          {receipt.total_benefit !== '0.00' && receipt.status !== 'review_requested' ? (
            <EnrichedReceipt />
          ) : (
            <div className="bg-primary-platinum flex h-8 w-8 shrink-0 items-center justify-center rounded">
              <SingleReceipt />
            </div>
          )}
          <div>
            <p className="text-base font-medium">
              {receipt.merchant_name} {receipt.merchant_address && ' - ' + receipt.merchant_address}
            </p>
            <p className="text-xs font-normal opacity-70">
              {formattedTransactionDate && `Transaction ${formattedTransactionDate}`} | Processed{' '}
              {formattedProcessedDate}
            </p>
            <Link href={`/receipts/${receiptId}/view-image`}>
              <button className="hover:text-primary-600 text-primary text-xs font-normal">
                View image
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
